export const MIN_DISPLAYED_METRICS_COUNT = 4;
export const MAX_DISPLAYED_METRICS_COUNT = 4;
